import ExtendedView from './Views/ExtendedView';
import StandardView from './Views/StandardView';

import type { FormGuideMatch } from '@shared-types/form-guide.types';
import type { Team } from '@shared-types/match.types';

export const FormGuideMatches = ({
  matches,
  team,
  extendedView,
}: {
  matches: FormGuideMatch[];
  team: Team;
  extendedView: boolean;
}) => {
  return (
    <>
      {extendedView && <ExtendedView matches={matches} team={team} />}
      {!extendedView && <StandardView matches={matches} team={team} />}
    </>
  );
};
